/** @jsx jsx */
import React, { ReactNode } from 'react';
import { css, jsx } from '@emotion/core';
import { Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { Text, Title } from 'components/Texts';
import { ChallengePhaseType } from 'interfaces';
import { CHALLENGE_PHASE } from 'constants/challenges';

export const cssDisplayBlock = css({
  display: 'block',
});

type PhotosContainerProps = {
  children?: ReactNode;
  currentPhase: ChallengePhaseType | null;
  isWaitingModeration: boolean | null;
};

const PhotosContainer = ({
  children,
  currentPhase,
  isWaitingModeration,
}: PhotosContainerProps): JSX.Element => {
  const { t } = useTranslation();
  const isAfterChallenge = currentPhase === CHALLENGE_PHASE.AFTER_CHALLENGE;
  let firstText = t('photo_contest.rank.be_the_first');
  if (isWaitingModeration) {
    firstText = t('photo_contest.rank.waiting_moderation');
  }
  if (isAfterChallenge) {
    firstText = t('photo_contest.rank.no_participant');
  }

  if (React.Children.count(children) >= 1) {
    // Fragment needed because of the returm type JSX.Element
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <Grid item css={{ marginTop: 50 }}>
      <Title
        color="primary"
        size="h2"
        textCase="sentence"
        isParagraph
        position="center"
        css={cssDisplayBlock}
      >
        {firstText}
      </Title>
      <Text position="center" css={cssDisplayBlock}>
        {t(
          isAfterChallenge
            ? 'photo_contest.rank.see_you_next_time'
            : 'photo_contest.rank.come_back_later_to_vote',
        )}
      </Text>
    </Grid>
  );
};

export default PhotosContainer;
